import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const InitialProfitPage = ({ startDate, endDate }) => {
  const location = useLocation();
  const [filteredLoans, setFilteredLoans] = useState([]);
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseURL = process.env.REACT_APP_BASE_URL;

  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");
        const response = await axios.get(`${baseURL}/getAllLoan`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setCollections(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (startDate && endDate && collections.length > 0) {
      const start = new Date(formatDate(startDate));
      const end = new Date(formatDate(endDate));

      const filteredCollections = collections.filter((collection) => {
        const collectionDate = new Date(collection.start_date);
        return collectionDate >= start && collectionDate <= end;
      });

      setFilteredLoans(filteredCollections);
    }
  }, [startDate, endDate, collections]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-lg font-semibold text-gray-600">Loading…</p>
      </div>
    );
  }
  return (
    <div className="p-5 bg-gray-50">
      <h2 className="text-lg font-bold mb-3 text-center">
        Initial Profit Report
      </h2>
      <div className="text-center mb-5">
        <h3 className="text-lg font-bold mb-3 text-center">
          {startDate} - {endDate}
        </h3>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden text-center">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-2 px-4 border border-gray-300 text-left w-10">
                Customer Name
              </th>
              <th className="py-2 px-4 border border-gray-300 text-left w-10">
                Loan ID
              </th>
              <th className="py-2 px-4 border border-gray-300 text-left w-20">
                Initial Profit
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredLoans.length > 0 ? (
              filteredLoans.map((loan, idx) => (
                <tr
                  key={loan.id}
                  className={`${
                    idx % 2 === 0 ? "bg-white" : "bg-gray-100"
                  } border-b border-gray-200`}
                >
                  <td className="py-2 px-4 border border-gray-300 text-left w-10">
                    {loan.tamilname || loan.customer_id}
                  </td>
                  <td className="py-2 px-4 border border-gray-300 text-left w-10">
                    {loan.loan_id}
                  </td>
                  <td className="py-2 px-4 border border-gray-300 text-left w-20">
                    ₹{parseFloat(loan.initial_profit || 0).toFixed(2)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="py-2 px-4 text-center" colSpan="3">
                  No data available for the selected date range.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InitialProfitPage;
